import React from 'react';
import {PageHeader, Select} from 'antd';
import {SelectProps} from 'antd/lib/select';
import {CollectionWorkProjectStatusConfig} from '../../hooks/apis/useCollectionWorkProjectRecord';
type IProps = SelectProps<CollectionWorkProjectStatusConfig>;

const CollectionWorkProjectStatusConfigSelector = (props: IProps) => {
  return (
    <Select {...props}>
      <Select.Option value={CollectionWorkProjectStatusConfig.关闭}>关闭</Select.Option>
      <Select.Option value={CollectionWorkProjectStatusConfig.开启}>开启</Select.Option>
      <Select.Option value={CollectionWorkProjectStatusConfig.自动}>自动</Select.Option>
    </Select>
  );
};
export default CollectionWorkProjectStatusConfigSelector;
